import React, { useEffect, useState, useRef, useContext } from 'react';
import Controls_Map_Floors from '../InteractiveMap/Controls_Map_Floors';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import Render_MapEditor from './Render_MapEditor';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { Floors_Upload_Image } from '../../api/API_Floors';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Button from '../ERUMAUI/UI_Button';
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png';
import Icon_Save from '../../Assets/Icons/Icon_Save.png';
import Icon_Restore from '../../Assets/Icons/Icon_Restore.png';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';

export default function Panel_MapEditor_Right() {
    // const { Account, Loading } = useAuth();


    const { Map_Information_Type, Map_Information, Map_Information_Set } = useMapRenderer();
    const { Map_Editing, Map_Editing_Set, Map_Editing_Mode, Building_Update, Floor_Update, Room_Update, Item_Delete_Confirm, Item_Restore_Confirm } = useMapEditor();
    const { Time_Parse } = useScheduleManagement();
    const { List_Unsaved, List_Unsaved_Set } = useStatus();
    const UI = useContext(Context_UI);

    const Handle_Save = async () => {
        if (Map_Information_Type == "Building") {
            const Verdict = await UI.Input_Evaluate([
                {
                    Type: "Text",
                    ID: "MapEditor_Building_Name_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Building_Address_Input",
                    AC: ""
                }
            ]);
            if (Verdict == true) {
                const Payload = {
                    ...Map_Information,
                    Name: UI.Element_Value_Get("MapEditor_Building_Name_Input"),
                    Address: UI.Element_Value_Get("MapEditor_Building_Address_Input")
                }
                await Building_Update(Map_Information._id, Payload);
            }
        }
        if (Map_Information_Type == "Floor") {
            const Verdict = await UI.Input_Evaluate([
                {
                    Type: "Text",
                    ID: "MapEditor_Floor_Number_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Floor_Name_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Floor_Plan_URL_Input",
                    AC: ""
                }
            ]);
            if (Verdict == true) {
                const Payload = {
                    ...Map_Information,
                    Number: UI.Element_Value_Get("MapEditor_Floor_Number_Input"),
                    Name: UI.Element_Value_Get("MapEditor_Floor_Name_Input"),
                    Plan: {
                        ...Map_Information.Plan,
                        // FileURL: UI.Element_Value_Get("MapEditor_Floor_Plan_URL_Input"),
                        FileURL: Floor_Plan_URL,
                        FileDateModified: new Date()
                    }
                }
                await Floor_Update(Map_Information._id, Payload);
            }
        }
        if (Map_Information_Type == "Room") {
            const Verdict = await UI.Input_Evaluate([
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Name_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Code_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Type_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Capacity_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Location_X_Input",
                    AC: ""
                },
                {
                    Type: "Text",
                    ID: "MapEditor_Room_Location_Y_Input",
                    AC: ""
                }
            ]);
            if (Verdict == true) {
                const Payload = {
                    ...Map_Information,
                    Name: UI.Element_Value_Get("MapEditor_Room_Name_Input"),
                    Type: UI.Element_Value_Get("MapEditor_Room_Type_Input"),
                    Capacity: UI.Element_Value_Get("MapEditor_Room_Capacity_Input"),
                    Location: {
                        ...Map_Information.Location,
                        Code: UI.Element_Value_Get("MapEditor_Room_Code_Input"),
                        Coordinates: {
                            ...Map_Information.Location.Coordinates,
                            X: UI.Element_Value_Get("MapEditor_Room_Location_X_Input"),
                            Y: UI.Element_Value_Get("MapEditor_Room_Location_Y_Input")
                        }
                    },
                    Restrictions: Restrictions
                }
                await Room_Update(Map_Information._id, Payload);
            }
        }

    }

    const Handle_Change = () => {
        if (!List_Unsaved.includes("Map Editor")) {
            List_Unsaved_Set(Previous => [...Previous, "Map Editor"]);
        }
    }

    const Handle_Delete = () => {
        Item_Delete_Confirm(Map_Information_Type);
    }

    const Handle_Delete_Permanent = () => {

    }

    const Handle_Restore = () => {
        Item_Restore_Confirm(Map_Information_Type);
    }

    // const Building_Rooms_Count_Get = (Index) => {
    //     if (Map_Information_Type == "Building") {
    //         let Rooms_Count = 0;
    //         let Building = Map_Composition;
    //         console.log(Building);
    //         Building.Floors.forEach(Floor => {
    //             // Rooms_Count += Floor.Rooms.length;
    //             console.log(Floor);
    //         });
    //         return "HEY";
    //     }

    // }

    const Format_Time = (dateTemp, Type) => {
        const date = new Date(dateTemp);
        if (!(date instanceof Date) || isNaN(date)) return "?";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    const [Restrictions, Restrictions_Set] = useState(null);

    useEffect(() => {
        if (Map_Information_Type === "Room" && Map_Information.Restrictions !== null) {
            Restrictions_Set(Map_Information.Restrictions);
        }
    }, [Map_Information]);

    const Handle_Time_Change = async (Event, Index, Side) => {
        // console.log(Event.target.value);
        const Verdict = await UI.Input_Evaluate([
            {
                Type: "Time_Range",
                ID_Start: `BlockedDay_${Index}_Start`,
                ID_End: `BlockedDay_${Index}_End`,
                AC: "Past",
                Prompt: "Invalid time"
            }
        ]);
        const Room_Type_Updated = { ...Restrictions };
        const Value = new Date(`2025-10-15T${Event.target.value}`);
        if (Side === "Start") {
            Room_Type_Updated.BlockedHours[Index].Start = Value;
        } else if (Side === "End") {
            Room_Type_Updated.BlockedHours[Index].End = Value;
        }

        // console.log(Room_Type_Updated);
        Restrictions_Set(Room_Type_Updated);
    }

    useEffect(() => {
        const Handle_Toggle_BlockedDay = ({ ID, State }) => {
            let Index = 0;
            if (ID.split("_")[2]) {
                Index = ID.split("_")[2];
            }
            // console.log(State);
            if (ID.split("_")[0] === "BlockedDay" && ID.split("_")[1] === "Toggle") {
                Handle_Toggle(Index, State);
            }
            if (ID.split("_")[0] === "Airconditioning" && ID.split("_")[1] === "Toggle") {
                Handle_Toggle_Airconditioning(State);
            }
            if (ID.split("_")[0] === "BlockedHours" && ID.split("_")[1] === "Toggle") {
                Handle_Toggle_BlockedHours(State);
            }
        }
        UI.on("Button_Toggled", Handle_Toggle_BlockedDay);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle_BlockedDay)
        };
    });

    const Handle_Toggle = (Index, State) => {
        const Room_Type_Updated = { ...Restrictions };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Room_Type_Updated.BlockedHours[Index].Block = State_New;
        Restrictions_Set(Room_Type_Updated);
    }

    const Handle_Toggle_Airconditioning = (State) => {
        const Room_Type_Updated = { ...Restrictions };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Room_Type_Updated.hasAirconditioner = State_New;
        Restrictions_Set(Room_Type_Updated);
    }

    const Handle_Toggle_BlockedHours = (State) => {
        const Room_Type_Updated = { ...Restrictions };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Room_Type_Updated.hasBlockedHours = State_New;
        Restrictions_Set(Room_Type_Updated);
    }

    const [Floor_Plan_File, Floor_Plan_File_Set] = useState(null);
    const [Floor_Plan_URL, Floor_Plan_URL_Set] = useState("");

    const Handle_File_Change = (e) => {
        Floor_Plan_File_Set(e.target.files[0]);
    };

    const Handle_File_Upload = async () => {
        if (!Floor_Plan_File) return;
        try {
            const formData = new FormData();
            formData.append("image", Floor_Plan_File);

            const result = await Floors_Upload_Image(formData);

            Floor_Plan_URL_Set(result.data.imageUrl);
            UI.Element_Value_Set("MapEditor_Floor_Plan_URL", result.data.imageUrl);

            // console.log("UPLOAD RESULT:", result.data);
            Map_Information_Set(Previous => ({
                ...Previous,
                Plan: {
                    ...Previous.Plan,
                    FileURL: result.data.imageUrl
                }
            }))
        } catch {
            UI.Element_Value_Set("MapEditor_Floor_Plan_URL", "Error. Try again.");
        }

    };

    return (
        <div className='ME'>
            {Map_Information_Type && (!Map_Information?.isDeleted || Map_Editing_Mode === "Bin") ?
                <>
                    <div className='ME_Info'>
                        {/* {Map_Information._id} */}
                        {Map_Information_Type == "Building" ?
                            <>
                                <h1 className='General_Title'>
                                    {Map_Information.Name}
                                </h1>
                                <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Building name:" Figure={Map_Information.Name} id="MapEditor_Building_Name" onInput={Handle_Change} />
                                <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Address:" Figure={Map_Information.Address} id="MapEditor_Building_Address" onInput={Handle_Change} />
                                {/* <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                    <UI_Card Type="Panel_Info" Text="Number of floors:" Figure={Map_Information.Floors.length} />
                                    <UI_Card Type="Panel_Info" Text="Number of reservable rooms:" Figure="?" />
                                </div> */}
                            </>
                            :
                            Map_Information_Type == "Floor" ?
                                <>
                                    <h1 className='General_Title'>
                                        {Map_Information.Name}
                                    </h1>
                                    {/* <UI_Card Type="Panel_Info" Text="Building:" Figure={Map_Information.Building} /> */}
                                    <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Floor level:" Figure={Map_Information.Number} id="MapEditor_Floor_Number" onInput={Handle_Change} />
                                    <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Floor name:" Figure={Map_Information.Name} id="MapEditor_Floor_Name" onInput={Handle_Change} />
                                    {/* <UI_Card Type="Panel_Info" Text="Number of reservable rooms:" Figure={Map_Information.Rooms.length} onInput={Handle_Change} /> */}
                                    <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Floor plan link:" Figure={Map_Information.Plan.FileURL} id="MapEditor_Floor_Plan_URL" onInput={Handle_Change} />
                                    {Map_Editing ?
                                        <>
                                            <input
                                                type="file"
                                                onChange={Handle_File_Change}
                                                accept="image/png, image/jpeg, image/svg, image/svg+xml"
                                            />
                                            <UI_Button
                                                Text="Upload new floor plan"
                                                OnClick={Handle_File_Upload}
                                            />
                                        </>
                                        :
                                        ""
                                    }

                                    <UI_Card Type="Panel_Info_Image" Text="Floor plan preview:" Figure={Map_Information.Plan.FileURL} />
                                    {/* {Map_Editing ?
                                        <>
                                            <UI_Divider Text="Batch actions" />
                                            <UI_Button Text="Set class hours" />
                                        </>
                                        :
                                        ""
                                    } */}

                                </>
                                :
                                Map_Information_Type == "Room" ?
                                    <>
                                        <h1 className='General_Title'>
                                            {Map_Information.Name}
                                        </h1>
                                        <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Room name:" Figure={Map_Information.Name} id="MapEditor_Room_Name" onInput={Handle_Change} />
                                        <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Room code:" Figure={Map_Information.Location.Code} id="MapEditor_Room_Code" onInput={Handle_Change} />
                                        <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Capacity:" Figure={Map_Information.Capacity} id="MapEditor_Room_Capacity" onInput={Handle_Change} />
                                        <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Room type:" Figure={Map_Information.Type} id="MapEditor_Room_Type" onInput={Handle_Change} />
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                            <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Map X location:" Figure={Map_Information.Location.Coordinates.X} id="MapEditor_Room_Location_X" onInput={Handle_Change} />
                                            <UI_Card Type={Map_Editing ? "Panel_Info_Editable" : "Panel_Info"} Text="Map Y location:" Figure={Map_Information.Location.Coordinates.Y} id="MapEditor_Room_Location_Y" onInput={Handle_Change} />
                                        </div>
                                        {Map_Editing ?
                                            <>
                                                <UI_Divider Text="Set airconditioning" />
                                                <UI_Toggle
                                                    id={`Airconditioning_Toggle`}
                                                    Text="This room has airconditioning"
                                                    Selected={Map_Information?.Restrictions?.hasAirconditioner ? "true" : "false"}
                                                />
                                                <UI_Divider Text="Set class hours" />
                                                <UI_Toggle
                                                    id={`BlockedHours_Toggle`}
                                                    Text="This room has class hours"
                                                    Selected={Map_Information?.Restrictions?.hasBlockedHours ? "true" : "false"}
                                                />
                                                <table className='ME_BlockedHours' View="Edit">
                                                    <thead>
                                                        <tr>
                                                            <td>
                                                                <p className='General_Paragraph'>
                                                                    Day
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p className='General_Paragraph'>
                                                                    Controls
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p className='General_Paragraph'>
                                                                    Start time
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p className='General_Paragraph'>
                                                                    End time
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Map_Information?.Restrictions?.BlockedHours.map((Item, Index) => (
                                                            <tr>
                                                                <td>
                                                                    <p className='General_Paragraph'>
                                                                        {Item.Day}
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <UI_Toggle
                                                                        id={`BlockedDay_Toggle_${Index}`}
                                                                        Text="Block hours"
                                                                        Selected={Item.Block ? "true" : "false"}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {Item.Block ?
                                                                        <UI_Input_Text
                                                                            id={`BlockedDay_${Index}_Start`}
                                                                            Input_Type='time'
                                                                            Value={Format_Time(Item.Start, "time")}
                                                                            onChange={(Event) => Handle_Time_Change(Event, Index, "Start")}
                                                                        />
                                                                        :
                                                                        <p className='General_Paragraph'>
                                                                            Free all day
                                                                        </p>
                                                                    }

                                                                </td>
                                                                <td>
                                                                    {Item.Block ?
                                                                        <UI_Input_Text
                                                                            id={`BlockedDay_${Index}_End`}
                                                                            Input_Type='time'
                                                                            Value={Format_Time(Item.End, "time")}
                                                                            onChange={(Event) => Handle_Time_Change(Event, Index, "End")}
                                                                        />
                                                                        :
                                                                        <p className='General_Paragraph'>
                                                                            -
                                                                        </p>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>
                                            :
                                            <>
                                                {Map_Information?.Restrictions?.hasAirconditioner ?
                                                    <>
                                                        <UI_Divider Text="Airconditioning" />
                                                        <p className='General_Paragraph'>
                                                            This room has airconditioning. When a requestant wants to use this room, they may opt to use its airconditioning system, which requires approval from the GSU administrator.
                                                        </p>
                                                    </>
                                                    :
                                                    ""
                                                }
                                                {Map_Information?.Restrictions?.hasBlockedHours ?
                                                    <>
                                                        <UI_Divider Text="Class hours" />
                                                        <p className='General_Paragraph'>
                                                            This room has class hours. When a reservation collides with these hours, the requestant will be warned.
                                                        </p>
                                                        <table className='ME_BlockedHours' View="View">
                                                            <thead>
                                                                <tr>
                                                                    <td>
                                                                        <p className='General_Paragraph'>
                                                                            Day
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className='General_Paragraph'>
                                                                            Start time
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className='General_Paragraph'>
                                                                            End time
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Map_Information?.Restrictions?.BlockedHours.map((Item, Index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <p className='General_Paragraph'>
                                                                                {Item.Day}
                                                                            </p>
                                                                        </td>
                                                                        <td>
                                                                            {Item.Block ?
                                                                                <p className='General_Paragraph'>
                                                                                    {Time_Parse(Item.Start, "Time")}
                                                                                </p>
                                                                                :
                                                                                <p className='General_Paragraph'>
                                                                                    Free all day
                                                                                </p>
                                                                            }

                                                                        </td>
                                                                        <td>
                                                                            {Item.Block ?
                                                                                <p className='General_Paragraph'>
                                                                                    {Time_Parse(Item.End, "Time")}
                                                                                </p>
                                                                                :
                                                                                <p className='General_Paragraph'>
                                                                                    -
                                                                                </p>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                    :
                                                    ""
                                                }

                                            </>
                                        }
                                    </>
                                    :
                                    ""
                        }
                    </div>
                    <div className='ME_Info_Controls'>
                        {Map_Editing && Map_Editing_Mode == "Regular" ?
                            <UI_LinearGroup Fill Gap="Gap">
                                <UI_Button Text="Delete this item" Icon={Icon_Delete} Icon_Position="Left" State="Negative" OnClick={Handle_Delete} />
                                <UI_Button Text="Save changes" Icon={Icon_Save} Icon_Position="Left" State="Positive" OnClick={Handle_Save} />
                            </UI_LinearGroup>
                            :
                            ""
                        }
                        {!Map_Editing && Map_Editing_Mode == "Bin" ?
                            <UI_LinearGroup Fill Gap="Gap">
                                {/* <UI_Button Text="Delete permanently" Icon={Icon_Delete} Icon_Position="Left" State="Negative" OnClick={Handle_Delete_Permanent} /> */}
                                <UI_Button Text="Restore" Icon={Icon_Restore} Icon_Position="Left" State="Neutral" OnClick={Handle_Restore} />
                            </UI_LinearGroup>
                            :
                            ""
                        }
                    </div>
                </>
                :
                ""
            }

        </div>

    );

}


